/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ILxsHeroHeaderButton contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum buttonType {
    primary = 'primary',
    secondary = 'secondary'
}

export const enum icon {
    arrow = 'arrow',
    cart = 'cart',
    mail = 'mail',
    plus = 'plus',
    reload = 'reload',
    search = 'search',
    truck = 'truck'
}

export interface ILxsHeroHeaderButtonConfig extends Msdyn365.IModuleConfig {
    link?: ILinkData;
    buttonType: buttonType;
    icon?: icon;
    visible?: boolean;
}

export interface ILxsHeroHeaderButtonResources {}

export interface ILinkData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface ILxsHeroHeaderButtonProps<T> extends Msdyn365.IModule<T> {
    resources: ILxsHeroHeaderButtonResources;
    config: ILxsHeroHeaderButtonConfig;
}
